var map = {
	"./0/first-m.png": 4214,
	"./1/first-m.png": 2440,
	"./2/first-m.png": 8064,
	"./3/first-m.png": 5529,
	"./4/first-m.png": 5069,
	"./5/first-m.png": 4415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6399;